<template>
  <Query :query="checkoutAddonsGQL" :variables="{ hash }" :adaptor="adaptor">
    <template #loading>
      <ShimmerCartSection />
    </template>
    <template #default="{ data: { checkoutAddons } }">
      <StoreCartSection
        v-if="checkoutAddons && checkoutAddons.length > 0"
        :title="$t('addons')"
      >
        <div class="divide-y dark:bg-gray-900">
          <StoreCheckoutAddon
            v-for="(addon, index) in checkoutAddons"
            :key="`addon-${index}`"
            :name="addon.name"
            :options="addon.options"
            :status="addon.status"
            :desc="addon.desc"
          />
        </div>
      </StoreCartSection>
    </template>
  </Query>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useCartStore } from "@/store/cart.js";
import checkoutAddons from "@/graph/store/checkout-addons.gql";

export default {
  data() {
    return {
      checkoutAddonsGQL: checkoutAddons,
    };
  },
  computed: {
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useCartStore, ["checkoutAddonsId"]),
  },

  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),

    adaptor({ checkoutAddons: { data } = {} }) {
      const checkoutAddons = data.filter((addon) => {
        if (addon.status !== "active") {
          return false;
        }
        const hasActiveOption = addon?.options.some(
          (option) => option.status === "active"
        );
        return hasActiveOption ? addon : false;
      });
      return { checkoutAddons };
    },
  },
};
</script>
